import { inject, Injectable } from '@angular/core';
import { ApiGatewayService } from './api-gateway.service';
import { User, UserGroup } from '../users/shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private gateway: ApiGatewayService = inject(ApiGatewayService);

  constructor() {}

  getUsers(): Observable<User[]> {
    return this.gateway.get<User[]>('/users');
  }

  getUser(username: string) {
    return this.gateway.get<User>('/users/' + username);
  }

  updateUser(updatedUser: FormData) {
    return this.gateway.post<FormData, any>('/users/update', updatedUser);
  }

  createUser(newUser: FormData) {
    return this.gateway.post<FormData, any>('/users', newUser);
  }

  getUserGroups() {
    return this.gateway.get<UserGroup[]>('/users/groups');
  }

  checkEmail(email: string) {
    return this.gateway.get<any>('/users/emails/check/' + email);
  }

  signature_url(username: string) {
    return this.gateway.endpoint + '/users/' + username + '/signature';
  }
}
